import React, { memo } from "react";
import { Button, Typography } from "antd";
import { ArrowLeftOutlined, HomeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import "./style.scss";

const { Title, Paragraph, Text } = Typography;

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found" data-testid="not-found-page">
      <div className="not-found__glow" aria-hidden />
      <div className="not-found__panel">
        <div className="not-found__badge" aria-hidden>
          <span className="not-found__badge-code">404</span>
        </div>

        <Title level={2} className="not-found__title">
          This page is off the map
        </Title>
        <Paragraph className="not-found__subtitle">
          The link may be outdated, mistyped, or the page may have moved.
          Head back home or use the sidebar to find what you need.
        </Paragraph>

        <div className="not-found__hints">
          <Text type="secondary">Try one of these:</Text>
          <ul>
            <li>Open a domain from the sidebar</li>
            <li>Check the URL for typos</li>
            <li>Return to the Nexus home page</li>
          </ul>
        </div>

        <div className="not-found__actions">
          <Button
            type="primary"
            size="large"
            icon={<HomeOutlined />}
            onClick={() => navigate("/")}
          >
            Back to home
          </Button>
          <Button
            size="large"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
          >
            Go back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default memo(NotFound);
